module.exports = __webpack_public_path__ + "static/media/FM.3625795b.png";